import React from 'react';
import { Iconfont } from '@umu/umu-design';
import { ICON_TYPES } from './constants';

/**
 * 导航按钮组件
 */
interface NavigationButtonProps {
    direction: 'up' | 'down';
    disabled: boolean;
    onClick: () => void;
}

const NavigationButton: React.FC<NavigationButtonProps> = React.memo(({ direction, disabled, onClick }) => {
    const className = `search-pdf-toolbar-icon search-pdf-toolbar-icon-${direction}`;
    const ariaLabel = direction === 'up' ? 'previous result' : 'next result';

    return (
        <Iconfont
            type={ICON_TYPES.DROPDOWN}
            className={className}
            onClick={disabled ? undefined : onClick}
            style={{
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.5 : 1,
                transform: direction === 'up' ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
            aria-label={ariaLabel}
            role="button"
            tabIndex={disabled ? -1 : 0}
        />
    );
});

NavigationButton.displayName = 'NavigationButton';

export { NavigationButton };
export type { NavigationButtonProps };
